var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "camera2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 17.047l-5-2.003v-4.008l5-2.004c0.553 0 1 0.449 1 1.002v6.012c0 0.553-0.447 1.001-1 1.001zM17.5 10.033c-2.485 0-4.5-2.019-4.5-4.509s2.015-4.509 4.5-4.509 4.5 2.019 4.5 4.509c0 2.491-2.015 4.509-4.5 4.509zM8.5 10.033c-2.485 0-4.5-2.019-4.5-4.509s2.015-4.509 4.5-4.509 4.5 2.019 4.5 4.509c0 2.491-2.015 4.509-4.5 4.509zM21 10.033v9.018h-5.582c-0.052 0.832-0.416 1.549-0.957 1.955h0.564l3.989 8.996h-0.994l-1.33-3h-2.66v4.998h-0.997v-4.998h-2.702l-1.351 3h-0.995l4.052-8.996h0.377c-0.541-0.406-0.905-1.123-0.957-1.955h-6.457v-9.018h16zM13.032 21.316c-0.041-0.010-0.079-0.031-0.119-0.045l-2.132 4.732h2.251v-4.687zM14.029 21.244v4.76h2.217l-2.126-4.795c-0.029 0.014-0.059 0.023-0.091 0.035z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.6411ff192cde3012d605e424788879ec.svg";
export { ForwardRef as ReactComponent };